import {useContext} from 'react';

import {
  Typography,
  useTheme,
} from '@mui/material';
import {
  Stack,
} from '@zoom/react-ui';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import CancellationContext from './CancellationContext';

import CalendarIllustration from 'assets/svg/calendar-illustration-plain.svg';
import {ZmTertiaryBtn} from 'Components/ZmButtons';
import useIsAutoRefundLimit from 'hooks/useIsAutoRefundLimit';
import {formatPriceTo2Decimal, getParentApptId} from 'Utils';
import {CURRENCY_SYMBOL} from 'Utils/consts';


export const CANCELLED_TYPE = Object.freeze({
  COMPLETED: 'completed',
  ALREADY_DECLINED: 'declined',
  ALREADY_CANCELLED: 'alreadyCancelled',
});

/**
 * CancellationResult Component
 * @param {Object} props
 * @param {Object} props.eventInfo booked event info object
 * @return {ReactElement}
 */
export default function CancellationResult(props) {
  const {eventInfo} = props;
  const {t} = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const {timeZone} = useContext(CancellationContext);

  const apptId = getParentApptId(eventInfo.appointmentId);
  const apptSlug = eventInfo.originalEvent?.slug;
  const userSlug = eventInfo.originalEvent?.user;
  const bookingLinkURL = (apptSlug) ?
    `/${userSlug}/${apptSlug}` :
    `/${userSlug}/${apptId}`;

  const currency = eventInfo.attendees?.[0]?.currency;
  const currencySymbol = CURRENCY_SYMBOL[currency];
  const amount = eventInfo.attendees?.[0]?.totalFee || 0;
  const displayAmount = `${currencySymbol}${amount}`;

  const isAutoRefundLimit = useIsAutoRefundLimit(eventInfo.originalEvent?.start.dateTime, timeZone);

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      sx={{width: '100%'}}
    >
      <img height="100" width="100" src={CalendarIllustration} alt="calendar"/>
      <Typography align="center"
        sx={{color: theme.palette.text.primary}}
      > {t('cancellation.successMsg', [eventInfo.hostDisplayName?.split(' ')[0]])}
      </Typography>
      {amount > 0 && !isAutoRefundLimit && <Typography align="center"
        sx={{color: theme.palette.text.primary}}
      > {t('payment.receiveRefund', [formatPriceTo2Decimal(displayAmount)])}
      </Typography>}
      {
        !eventInfo.fromSingleUseLink &&
        <ZmTertiaryBtn
          sx={{
            'width': '200px',
            // Adjusting the button height to auto to fit longer l10n text
            'minHeight': 'unset',
            'height': 'auto',
          }}
          size="small"
          onClick={()=> {
            navigate(bookingLinkURL);
          }}
        >
          {t('cancellation.another')}
        </ZmTertiaryBtn>
      }


    </Stack>
  );
}
